import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { clientService } from '../../../_services/client.service';
import { getDateString } from '../../../_helpers/dateTime.helper';
import { ClientMedicalInfoManageDrawer } from './client-medicalInfoManageDrawer';

export const ClientMedicalInfoPanel = () => {
    const { clientId } = useParams<{ clientId: string }>();
    const [data, setData] = useState<any>({ items: [] });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        if (!clientId) return;
        setIsLoading(true);
        return await clientService.getLatest(clientId)
            .then(
                json => {
                    console.log(json)
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [clientId]);

    const rows = [
        { label: 'Medical Card No.', value: data.medicalCardNo },
        { label: 'Medical Card Expiry', value: data.medicalCardExpiry ? getDateString(data.medicalCardExpiry) : "" },
        { label: 'Allergies', value: data.allergies },
    ]

    return (
        <>
            <StandardViewPanel
                title="Medical Info" buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageMedicalInfo/") } }
                ]} 
                loading={isLoading}
                items={rows} />
            <Routes>
                <Route path="ManageMedicalInfo/" element={<ClientMedicalInfoManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>
        </>
    );
};